import { MonitorKey } from './monitor-key.type';

export class PluralAssignment {
  MonitorKeys: MonitorKey[];
  IdPlaylist: number;

  constructor(keys: MonitorKey[], idPlaylist: number = null) {
    this.IdPlaylist = idPlaylist;
    this.MonitorKeys = keys;
  }
}
